import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import isHotkey from 'is-hotkey';
import { Document } from 'slate';
import BlockTypes from '../../types/BlockTypes';
import FileHelpers from '../../helpers/FileHelpers';
import getBlockId from '../../utils/getBlockId';
import renderBlocks from '../utils/renderBlocks';
import makeLightboxItems from '../utils/makeLightboxItems';
import makeToolbarButton, { BASIC_INSERTION, EXPANDED_INSERTION } from '../utils/makeToolbarButton';
import { ImageIcon } from '../../components/Icons';
import Image from './components/Image';
import serializers from './serializers';
export var schema = {
  blocks: _defineProperty({}, BlockTypes.IMAGE, {
    isVoid: true
  })
};

function onResize(editor, node, _ref) {
  var width = _ref.width;
  editor.setNodeByKey(node.key, {
    data: _objectSpread({}, node.data.toJS(), {
      width: width
    })
  });
}

export default (function () {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$enableLightbox = _ref2.enableLightbox,
      enableLightbox = _ref2$enableLightbox === void 0 ? false : _ref2$enableLightbox,
      _ref2$decorator = _ref2.decorator,
      decorator = _ref2$decorator === void 0 ? function (x) {
    return x;
  } : _ref2$decorator,
      _ref2$onDownload = _ref2.onDownload,
      onDownload = _ref2$onDownload === void 0 ? function (x) {
    return x;
  } : _ref2$onDownload;

  var Component = function Component(props) {
    var editor = props.editor,
        node = props.node;
    var parent = editor.value.document.getParent(node.key);
    var resizable = Document.isDocument(parent) || parent.nodes.size === 1;
    return React.createElement(Image, Object.assign({
      enableLightbox: enableLightbox,
      onDownload: onDownload,
      onResize: onResize,
      resizable: resizable
    }, props));
  };

  return [{
    serializers: serializers,
    schema: schema,
    commands: {
      removeImage: function removeImage(editor, node) {
        var parentNode = editor.value.document.getParent(node.key);
        var isOnlyImageInGallery = parentNode.nodes.size === 1 && parentNode.type === BlockTypes.IMAGE_GALLERY;
        var nodeKeyToRemove = isOnlyImageInGallery ? parentNode.key //Only image in the image gallery
        : node.key; //There are other images in the image gallery

        editor.removeNodeByKey(nodeKeyToRemove);
      }
    },
    onKeyDown: function onKeyDown(event, editor, next) {
      var _editor$value = editor.value,
          startBlock = _editor$value.startBlock,
          endBlock = _editor$value.endBlock,
          selection = _editor$value.selection;
      var isImageSelected = selection.isSet && selection.isCollapsed && startBlock.type === BlockTypes.IMAGE && endBlock.type === BlockTypes.IMAGE;

      if (isHotkey('backspace', event) && isImageSelected) {
        event.stopPropagation();
        event.preventDefault();
        editor.removeImage(startBlock);
      } else {
        return next();
      }
    }
  }, makeToolbarButton(BlockTypes.IMAGE, {
    icon: ImageIcon,
    title: 'Image',
    alias: ['img'],
    tip: 'Max image file size: 5MB',
    visibility: BASIC_INSERTION | EXPANDED_INSERTION,
    canApply: function canApply(editor) {
      return editor.isMutableBlock();
    },
    onApply: function onApply(editor) {
      return editor.command('openFileUpload', 'image/*');
    }
  }), renderBlocks(_defineProperty({}, BlockTypes.IMAGE, decorator(Component))), makeLightboxItems(BlockTypes.IMAGE, {
    renderItem: function renderItem(itemData) {
      return React.createElement("img", {
        className: "radius-normal background-white",
        style: {
          maxWidth: '100%',
          maxHeight: '100%'
        },
        alt: itemData.url,
        src: itemData.url
      });
    },
    getItems: function getItems(editor) {
      return editor.value.document.getBlocksByType(BlockTypes.IMAGE).map(function (node) {
        var imageData = node.data;
        var size = imageData.get('meta') && imageData.get('meta').size ? "".concat(FileHelpers.bytesToSize(imageData.get('meta').size)) : '';
        return {
          id: getBlockId(node),
          type: BlockTypes.IMAGE,
          url: imageData.get('url'),
          width: imageData.get('width') || 'auto',
          name: imageData.get('name'),
          createdBy: imageData.get('createdBy'),
          size: size
        };
      }).toJS();
    }
  })];
});